module.exports = __webpack_public_path__ + "static/media/mtb-bb.1dcc1008.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/mtb-bb.jpg
// module id = 85
// module chunks = 0